import { useContext } from 'react';

import { Box, Typography, useMediaQuery } from '@mui/material';

import CustomImageComponent from '@/components/shared/custom/custom-image';
import ApercibidosStatusIcon from '@/components/shared/icons/apercibidos-status-icon';
import { REDUCERS } from '@/constants/reducers';
import { Context } from '@/context';
import { getCountryImage, getMasterPhotoById } from '@/helpers/images-helper';
import { getPlayerIconWhenIsNotOk } from '@/helpers/players-helper';

const EquipoPlayerLineupSimpleMode = ({ player, onClick, customSize, banquillo = false }) => {
    const { dispatch } = useContext(Context);
    const id = player?.information?.id ?? 0;
    const isMobile = useMediaQuery('(max-width:576px)');
    let size = isMobile ? 70 : 80;

    if (customSize) {
        size = customSize;
    }

    const cardHeight = isMobile ? 120 : 130;

    const handleClick = (playerId) => {
        if (onClick) {
            onClick();
        } else if (playerId > 0) {
            dispatch({ type: REDUCERS.SHOW_MASTER_ACCIONES_PLAYER_ID, payload: playerId });
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: banquillo ? 'auto' : cardHeight,
                width: size,
            }}
            onClick={() => handleClick(id)}
        >
            <Box sx={{ position: 'relative', width: size, height: size }}>
                <CustomImageComponent
                    src={getMasterPhotoById(id, size * 1.5)}
                    alt="jugador"
                    width={size}
                    height={size}
                />

                {player?.generalStatus?.isApercibido && (
                    <ApercibidosStatusIcon
                        iconWidth={15}
                        iconHeight={15}
                        styles={{ position: 'absolute', bottom: 0, left: '8px' }}
                    />
                )}

                <Box style={{ position: 'absolute', bottom: 0, right: '5px' }}>
                    {player?.information?.id > 0 &&
                        getPlayerIconWhenIsNotOk(
                            player?.generalStatus?.status,
                            player?.generalStatus?.statusLevel
                        )}
                </Box>

                {player?.convocatoriaSeleccion?.isConvocado && (
                    <Box style={{ position: 'absolute', top: 0, right: 0 }}>
                        <CustomImageComponent
                            src={getCountryImage(player?.convocatoriaSeleccion?.countryCode, 30)}
                            width={20}
                            height={20}
                            alt="selección"
                            style={{ borderRadius: '50%' }}
                        />
                    </Box>
                )}
            </Box>

            <Typography
                variant="body2"
                sx={{
                    textAlign: 'center',
                    fontSize: '12px',
                    marginTop: '4px',
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {player?.information?.name ??
                    player?.name ??
                    player?.nickname ??
                    player?.information?.nickname}
            </Typography>
        </Box>
    );
};

export default EquipoPlayerLineupSimpleMode;
